import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { PrivateRoute, NotFound } from '@gsa/afp-shared-ui-utils';
import CatalogCodesProvider from './catalog-codes-provider';
import { OPERATIONS, SUBJECTS } from '../../utilities/constants';
import CatalogCodeDetail from './detail';
import CatalogCodesTable from './table';

const CatalogCodes = () => {
  const location = useLocation();
  return (
    <>
      <CatalogCodesProvider>
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute
                contextLocation={location}
                operation={OPERATIONS.View}
                subject={SUBJECTS.CatalogCodes}
              >
                <CatalogCodesTable />
              </PrivateRoute>
            }
          />
          <Route
            path="/:standardCodeMetadataId/:code"
            element={
              <PrivateRoute
                contextLocation={location}
                title="Catalog Code Detail"
                operation={OPERATIONS.View}
                subject={SUBJECTS.CatalogCodes}
              >
                <CatalogCodeDetail />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </CatalogCodesProvider>
    </>
  );
};

export default CatalogCodes;
